import React from 'react';
import { ordersApi } from '@/services/api';
import { formatSummaryAmount } from '@/utils/formatters';
import BaseProcessedInstructions from '@/components/orders/BaseProcessedInstructions';
import styles from '@/components/orders/OrderManagement.module.css';

interface EtfProcessedOrder {
  id: number;
  order_date: string;
  created_at: string;
  scheme: { id: number; code: string; base_currency?: string } | null;
  company: { id: number; symbol: string } | null;
  cash_env: number | null;
  cash_env_display: string | null;
  limit_price: string | null;
  order_status_display: string;
}

interface EtfProcessedInstructionsProps {
  onDeleteSuccess: () => void;
}

const EtfProcessedInstructions: React.FC<EtfProcessedInstructionsProps> = ({ onDeleteSuccess }) => (
  <BaseProcessedInstructions<EtfProcessedOrder, EtfProcessedOrder>
    titlePrefix="ETF"
    fetchBuyOrders={() => ordersApi.getProcessedEtfBuyInstructions()}
    fetchSellOrders={() => ordersApi.getProcessedEtfSellInstructions()}
    deleteBuyOrders={(data) => ordersApi.deleteEtfBuyOrders(data)}
    deleteSellOrders={(data) => ordersApi.deleteEtfSellOrders(data)}
    onDeleteSuccess={onDeleteSuccess}
    buyOrderTypeColumn={{
      header: 'Cash Environment',
      getValue: (order) => order.cash_env_display ?? '—',
    }}
    sellOrderTypeColumn={{
      header: 'Cash Environment',
      getValue: (order) => order.cash_env_display ?? '—',
    }}
    renderBuyHeaders={() => (
      <th className={styles.num}>Limit Price</th>
    )}
    renderSellHeaders={() => null}
    renderBuyRow={(order) => (
      <td className={`${styles['text-mono']} ${styles.num}`}>
        {order.limit_price ? formatSummaryAmount(order.limit_price, order.scheme?.base_currency ?? null) : '—'}
      </td>
    )}
    renderSellRow={() => null}
  />
);

export default EtfProcessedInstructions;